import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, { title: _ctx.label }, {
        default: _withCtx(() => [
            (_ctx._page)
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.$forms.componentPageName(_ctx._page?.pageType)), {
                    key: 0,
                    schema: _ctx._schema,
                    data: _ctx._data,
                    page: _ctx._page
                }, null, 8, ["schema", "data", "page"]))
                : _createCommentVNode("", true)
        ]),
        _: 1
    }, 8, ["title"]));
}
